import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";
import pt from "./locales/pt.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import ru from "./locales/ru.json";
import fi from "./locales/fi.json";
import no from "./locales/no.json";
import ja from "./locales/ja.json";
import ar from "./locales/ar.json";

export const LANGUAGES = ["EN", "ES", "PT", "DE", "FR", "IT", "RU", "FI", "NO", "JP", "AR"];
export const LANG_CODES = { EN: "en", ES: "es", PT: "pt", DE: "de", FR: "fr", IT: "it", RU: "ru", FI: "fi", NO: "no", JP: "ja", AR: "ar" };
export const RTL_LANGS = ["ar"];
export const tr = (key, options) => i18n.t(key, options);
export const locale = () => i18n.language || "en";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt },
      de: { translation: de },
      fr: { translation: fr },
      it: { translation: it },
      ru: { translation: ru },
      fi: { translation: fi },
      no: { translation: no },
      ja: { translation: ja },
      ar: { translation: ar },
    },
    fallbackLng: "en",
    supportedLngs: Object.values(LANG_CODES),
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "dc_lang",
    },
  });

i18n.on("languageChanged", (lng) => {
  const baseLanguage = (lng || "en").split("-")[0];
  if (baseLanguage !== lng && Object.values(LANG_CODES).includes(baseLanguage)) {
    i18n.changeLanguage(baseLanguage);
    return;
  }
  localStorage.setItem("dc_lang", baseLanguage);
  document.documentElement.lang = baseLanguage;
  document.documentElement.dir = RTL_LANGS.includes(baseLanguage) ? "rtl" : "ltr";
});

if (i18n.language) {
  const baseLanguage = i18n.language.split("-")[0];
  if (baseLanguage !== i18n.language && Object.values(LANG_CODES).includes(baseLanguage)) {
    i18n.changeLanguage(baseLanguage);
  } else {
    document.documentElement.lang = baseLanguage;
    document.documentElement.dir = RTL_LANGS.includes(baseLanguage) ? "rtl" : "ltr";
    localStorage.setItem("dc_lang", baseLanguage);
  }
}

export default i18n;
